import { AimmaProductStatus, getLocalized, HealthLang } from "./healthTypes";

const STATUS_LABELS: Record<
    AimmaProductStatus,
    { En: string; Zh: string; Jp: string }
> = {
    available: {
        En: "Available",
        Zh: "已推出",
        Jp: "提供中",
    },
    "under-development": {
        En: "Under development",
        Zh: "開發中",
        Jp: "開発中",
    },
    "future-extension": {
        En: "Planned",
        Zh: "規劃中",
        Jp: "準備中",
    },
    "planned-capability": {
        En: "Planned Capability",
        Zh: "規劃中功能",
        Jp: "計画中の機能",
    },
    "strategic-extension": {
        En: "Strategic Extension",
        Zh: "策略延伸",
        Jp: "戦略的拡張",
    },
};

const STATUS_STYLES: Record<AimmaProductStatus, string> = {
    available:
        "border-teal-200/70 bg-teal-50/60 text-teal-700",
    "under-development":
        "border-grey-200/80 bg-grey-50 text-grey-600",
    "future-extension":
        "border-teal-200/60 bg-[rgba(3,124,132,0.08)] text-teal-600",
    "planned-capability":
        "border-slate-200/80 bg-slate-50/80 text-slate-600",
    "strategic-extension":
        "border-teal-200/50 bg-teal-50/40 text-teal-600",
};

interface HealthProductStatusBadgeProps {
    status: AimmaProductStatus;
    lang: HealthLang;
    className?: string;
}

export function HealthProductStatusBadge({
    status,
    lang,
    className = "",
}: HealthProductStatusBadgeProps) {
    const label = getLocalized(STATUS_LABELS[status], lang);

    return (
        <span
            className={`inline-flex shrink-0 items-center rounded-full border px-2.5 py-0.5 text-left text-[10px] font-semibold leading-none tracking-wide [text-align:left] sm:text-[11px] ${STATUS_STYLES[status]} ${className}`}
        >
            {label}
        </span>
    );
}
